import React, { Component, Fragment } from "react";
import { Typography } from "@material-ui/core";

class DependentDropdown extends Component {
  render() {
    return (
      <Fragment>
        {this.props.element.answer?.map((ans) =>
          ans?.vendorId && ans?.vendorName ? (
            <Typography>{ans?.vendorName}</Typography>
          ) : ans?.regionId && ans?.regionName ? (
            <>
              <Typography>{ans?.regionName}</Typography>
              {ans?.siteId && ans?.siteName && (
                <Typography>{ans?.siteName}</Typography>
              )}
              {ans?.turbineId && ans?.turbineName && (
                <Typography>
                  {ans?.turbineName + " | " + ans?.turbineId}
                </Typography>
              )}
            </>
          ) : null,
        )}
      </Fragment>
    );
  }
}
export default DependentDropdown;
